export default "__VITE_ASSET__CN$DHDz8__"